import { Component } from '@angular/core';

@Component({
  selector: 'app-econet',
  standalone: true,
  imports: [],
  templateUrl: './econet.component.html',
  styleUrl: './econet.component.css'
})
export class EconetComponent {

}
